<template>
  <div class="x-table ub-box ub-ver-v">
    <table border="1" class="table ub-f1 z-width-80-precent">
      <thead @click.stop="XtheadClick($event)">
      <th v-for="(title, index) in columns" :data-key="title.key">{{title.label}}</th>
      </thead>
      <tbody ref="tbody" class="">
      <tr v-for="(item, index) in data" class="z-curPonit">
        <td class="z-textAlign-center" v-for="(column, ind) in columns">
          <xcell :cell-config="item[column['col']]" :cell-string="item[column['key']]" :index="index" :cell-index="ind" :string-before="column.stringBefore" :category="column.category" @XbuttonService="XbuttonService" @XcheckService="XcheckService"/>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  import Xcell from './Xcell.vue'
  export default {
    data() {
      return {
        type: 'sort',
        oldKey: ''
      }
    },
    props: {
      columns: {
        type: Array,
        default:()=> []
      },
      data: {
        type: Array,
        default:()=>[]
      },
      isHaveTheadClick: {
        type: Boolean,
        default: true
      }
    },
    components: {
      Xcell,
    },
    methods: {
      XbuttonService(type, index) {
        this.$emit('XbuttonService', type, index)
      },
      XcheckService(flag, index) {
        this.$emit('XcheckService', flag, index)
      },
      XtheadClick(e) {
        if( !this.isHaveTheadClick ) return
        let key = e.target.getAttribute('data-key')
        if(key == this.oldKey) {
          this.type = this.type === 'sort'? 'normal': 'sort'
          this.$emit('XtheadClick', key, this.type)
        }else {
          this.type = 'sort'
          this.$emit('XtheadClick', key, this.type)
        }
        this.oldKey = key
      }
    }
  }
</script>
<style scoped>
  .x-table {width: 100%;}
  .x-table .table {border-collapse: collapse; border-spacing: 0; empty-cells: show; border: 1px solid #e0e0e0; width: 100%; color: #5d5d5d; background: #fff;}
  .table tbody tr{transition: all .2s ease-in;}
  .table tbody tr:hover {background-color: #f9f9f9}
  .table td span {font-size: 14px;}
  .table thead th{ color: #5d5d5d; font-weight: normal;}
  .table thead th:hover {cursor: pointer;}
  .table th, .table td { padding: .5rem 1rem; line-height: 2.5rem; font-size: 14px; }
  @media screen and (max-width: 1600px) {
    .table th, .table td { padding: .5rem 1rem; line-height: 2rem; font-size: 14px; }
  }
</style>




// WEBPACK FOOTER //
// src/components/commons/XhomeTable.vue